import React, { useState } from "react";
import { IBusLicensePermitType } from "../types";
import { useRecoilValue } from "recoil";
import { useFormContext } from "react-hook-form";
import TextInputLabelHookForm from "components/TextInputLabelHookForm";
import CheckBoxLabelHookForm from "components/CheckBoxLabelHookForm";
import { editStateBusLicensePermitType } from "../atoms/atoms";

export default function BusLicensesPermitsTypeDetails(props: {
  setChanges: React.Dispatch<React.SetStateAction<boolean>>;
  data: IBusLicensePermitType | undefined;
}) {
  // Props drilled
  const { data, setChanges } = props;

  // Recoil Hook
  const edit = useRecoilValue(editStateBusLicensePermitType);

  // Form Functions
  const { register } = useFormContext();
  const formMethods = useFormContext();

  // Local Hooks
  const [inputData, setInputData] = useState(
    data?.busLicensePermitTypeName || ""
  );
  const [checkBoxChanges, setCheckBoxChanges] = useState(data?.isActive);

  return (
    <>
      <div className="bg-bgDB">
        <div className="m-2 bg-white box-shadow h-full">
          <div className="grid grid-cols-10 mx-3 gap-x-6 py-2">
            <div className="col-span-4 my-1">
              <TextInputLabelHookForm
                name="busLicensePermitTypeName"
                label="Business License Permit Type Name"
                type="text"
                onChange={(e) => {
                  setInputData(e.target.value);
                  if (
                    e.target.value.length === 0 ||
                    (e.target.value === data?.busLicensePermitTypeName &&
                      checkBoxChanges === data?.isActive)
                  ) {
                    setChanges(false);
                  } else {
                    setChanges(true);
                  }
                  e.target.value = e.target.value.replace(/\s+/g, " ");
                }}
                required={true}
                className={
                  formMethods.formState.errors.busLicensePermitTypeName &&
                  formMethods.formState.errors.busLicensePermitTypeName
                    .message &&
                  "border-2 border-red-500 col-span-2 "
                }
                register={formMethods.register("busLicensePermitTypeName", {
                  required: {
                    value: true,
                    message: "Required Field",
                  },
                })}
                maxLength={255}
              />
            </div>

            {edit && (
              <div className="col-span-4 my-1">
                <CheckBoxLabelHookForm
                  name="isActive"
                  label={
                    checkBoxChanges
                      ? "Uncheck to Deactivate"
                      : "Check to Activate"
                  }
                  type="checkbox"
                  validation={{
                    required: {
                      value: false,
                      message: "Required Field",
                    },
                  }}
                  onClick={(e) => {
                    setCheckBoxChanges(e.target.checked);
                    if (
                      inputData?.length === 0 ||
                      (e.target.checked === data?.isActive &&
                        inputData === data?.busLicensePermitTypeName)
                    ) {
                      setChanges(false);
                    } else {
                      setChanges(true);
                    }
                  }}
                  register={register}
                />
              </div>
            )}
          </div>
        </div>
      </div>
    </>
  );
}
